export default __webpack_public_path__ + "static/alumni-bg-2594da7b1980fb9710c5ab2fe0de5ac0.png";